module.exports = __webpack_public_path__ + "img/pebble.9d9ecf09.png";